import { Component, computed, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseItemComponent, IBaseItem } from '../../common-items/BaseItem/base-item-form.component';
import { BaseItemProperties, DEFAULT_BASE_PROPERTIES } from '../../common-items/BaseItem/base-item-properties';

import { getPropsFrom } from '../../../../utils/xmlParser';
import { getOptimalFirstColumnWidth } from '../../../../utils/getOptimalWidth';

interface MultiColumnTextProperties {
  text1: string;
  styleText1: string;
  text1Width: string;
  text2: string;
  styleText2: string;
  text2Width: string;
}

@Component({
  selector: 'lfe-multi-column-text-item-form',
  imports: [CommonModule],
  templateUrl: './multi-column-text-item-form.component.html',
  standalone: true,
  styleUrl: './multi-column-text-item-form.component.css'
})
export class MultiColumnTextItemFormComponent
  extends BaseItemComponent<MultiColumnTextProperties>
  implements OnInit, IBaseItem<MultiColumnTextProperties>
{
  @Output() updateFirstColumnWidthRequired = new EventEmitter<{ id: string; width: number }>();

  properties: BaseItemProperties & MultiColumnTextProperties = {
    ...DEFAULT_BASE_PROPERTIES,
    text1: '',
    styleText1: '',
    text1Width: '',
    text2: '',
    styleText2: '',
    text2Width: ''
  };

  override ngOnInit() {
    super.ngOnInit();

    const optimalWidth = getOptimalFirstColumnWidth(this.properties.text1);

    this.updateFirstColumnWidthRequired.emit({
      id: this.firstSiblingItemId(),
      width: optimalWidth
    });
  }

  currentId = computed(() => this.properties.customId || this.properties.id);

  htmlId = computed(() => `multi_column_text_${this.currentId()}`);

  firstColumnWidth = computed(
    () => this.sharedFirstColumnWidths()[this.firstSiblingItemId()] || getOptimalFirstColumnWidth(this.properties.text1)
  );

  firstColumnStyle = computed(() => ({
    width: `${this.firstColumnWidth()}px`
  }));

  extractLocalProperties(xml: Element) {
    const props = getPropsFrom(xml);

    const customId = props['CustomID'];
    const id = props['ID'];
    const text1 = props['Text1'] || '';
    const styleText1 = props['StyleText1'] || '';
    const text1Width = props['Text1Width'] || '';
    const text2 = props['Text2'] || '';
    const styleText2 = props['StyleText2'] || '';
    const text2Width = props['Text2Width'] || '';
    const activationRule = props['ActivationRule'] || '';
    const isGenericRepeatItem = props['IsGenericRepeatItem'] === 'True';

    return {
      ...DEFAULT_BASE_PROPERTIES,
      id,
      customId,
      activationRule,
      text1,
      styleText1,
      text1Width,
      text2,
      styleText2,
      text2Width,
      isGenericRepeatItem
    } as BaseItemProperties & MultiColumnTextProperties;
  }
}
